export default "__VITE_ASSET__DA$XOqqo__"